import { createCRUDApi } from "@/lib/api-factory";
import type {
  ProductBrand,
  ProductBrandCreate,
  ProductBrandUpdate,
} from "@/types/products/api-types/product-brand-types";

export const productBrandsApi = createCRUDApi<ProductBrand, ProductBrandCreate, ProductBrandUpdate>(
  "/products/brands"
);
